import { useMemo } from 'react';

export function useSerializableMemo(value) {
  const serialized = JSON.stringify(value);
  return useMemo(() => JSON.parse(serialized), [serialized]);
}
